import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

/**
 * CustomizationSection is one row of the Customizations block, each over its
 * own pane. Skills and Custom Instructions land here as siblings.
 */
export type CustomizationSection = 'project-memory';

interface CustomizationsState {
  /** section is the open one, or null while the panel shows the conversation. */
  section: CustomizationSection | null;
  /** collapsed hides the block's rows, leaving its header. */
  collapsed: boolean;

  openSection: (section: CustomizationSection) => void;
  closeSection: () => void;
  setCollapsed: (collapsed: boolean) => void;
}

/**
 * useCustomizationsStore holds which customization section the ARIA panel is
 * showing. Unpersisted, so a reload lands on the conversation.
 */
export const useCustomizationsStore = create<CustomizationsState>()(
  devtools(
    set => ({
      section: null,
      collapsed: false,

      openSection: section => set({section}),
      closeSection: () => set({section: null}),
      setCollapsed: collapsed => set({collapsed}),
    }),
    {name: 'WBAgentCustomizationsStore'}
  )
);

/**
 * closeCustomizationSection returns the panel to the conversation. Called by
 * the actions that mean "show me a chat" — picking a thread, starting a new
 * one, or opening the panel from elsewhere in the app.
 */
export function closeCustomizationSection(): void {
  useCustomizationsStore.getState().closeSection();
}
